import "./bootstrap";
import "./sass/app.scss";
import "admin-lte";
import Vue from "vue";
import VeeValidate from "vee-validate";
import axios from "axios";
import money from "v-money";
import VueCurrencyFilter from "vue-currency-filter";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";

axios.defaults.baseURL = "/";
Vue.prototype.$http = axios;

window.API_URL = "https://api.cashdepotint.com/v1"; // comentar esta linea en produccion ya que la tomara del env

Vue.use(money, {
    decimal: ".",
    thousands: ",",
    prefix: "RD$ ",
    suffix: "",
    precision: 2,
    masked: false,
});

Vue.use(VueCurrencyFilter, {
    symbol: "RD$",
    thousandsSeparator: ",",
    fractionCount: 2,
    fractionSeparator: ".",
    symbolPosition: "front",
    symbolSpacing: true,
});

Vue.use(VeeValidate, { fieldsBagName: "vvFields" });

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
